module.exports = __webpack_public_path__ + "img/login.d56376ec.jpg";